export default (state, payload) => {
  state.shappy.status = payload
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/mutations/setShopStatus.js